import React from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'
import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'

import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

// this banner will show after account is built but we don't have an access token for the user.
const NewCreditLineBanner = () => {
  const { track } = useWebTracking()

  useDidMount(() => {
    track('se_signup__application_dashboard_action_needed_account_created__presented')
  })

  return (
    <div className='dd-privacy-allow'>
      <StatusBanner
        bannerType={BannerType.Informative}
        subtext={
          <FormattedMessage
            defaultMessage='Be on the lookout for an email from us with next steps on how to set up your {BILL_SPEND_AND_EXPENSE}'
            id='sputnik.NewCreditLineBanner__dezVS5'
            values={{
              BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE,
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Congrats on your new credit line'
            id='sputnik.NewCreditLineBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default NewCreditLineBanner
